import React from 'react';

import Skeleton from 'react-loading-skeleton';

const SkeletonLoading: React.FC = () => {
  return <Skeleton width="100%" height={60} style={{ borderRadius: 5, marginBottom: 30 }} />;
};

export default SkeletonLoading;
